export function ChatAltIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.33333 6.66667H5.34M8 6.66667H8.00667M10.6667 6.66667H10.6733M6 10.6667H3.33333C2.59695 10.6667 2 10.0697 2 9.33333V4C2 3.26362 2.59695 2.66667 3.33333 2.66667H12.6667C13.403 2.66667 14 3.26362 14 4V9.33333C14 10.0697 13.403 10.6667 12.6667 10.6667H9.33333L6 14V10.6667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
